// extracted by mini-css-extract-plugin
module.exports = {"root":"SingleClient_root__3FeiD","name":"SingleClient_name__uQatM","actionButtons":"SingleClient_actionButtons__59MDk"};